import { TournFlags } from '@ps/web-poker-types';

import { BASE_POKER_STR, NGCDN_BASE_URL, TILE_IMAGE_FORMAT, getRailCdnBaseUrl } from './game';
import { getTournGroupStr } from './helpers';
import defaultImage from './imageCash';

export default function imageMttFormatter(
  game: number,
  buyIn: number,
  structure: number,
  isHiLo: number,
  satelliteTarget: number, // satellite
  maxPerTable: number, // heads up,
  tournGroup: number, // tournament group type,
  tournFlags: number,
  isThemeV2Image?: boolean
) {
  const railCdnBaseUrl = getRailCdnBaseUrl(!!isThemeV2Image);
  const imageUrl = `${railCdnBaseUrl}${BASE_POKER_STR}`;

  if (tournGroup > 0) {
    return `${NGCDN_BASE_URL}${BASE_POKER_STR}${getTournGroupStr(
      tournGroup,
      isThemeV2Image
    )}${TILE_IMAGE_FORMAT}`;
  }
  if (satelliteTarget !== 0) return `${imageUrl}satellite${TILE_IMAGE_FORMAT}`;
  if (maxPerTable === 2) return `${imageUrl}heads_up${TILE_IMAGE_FORMAT}`;
  // eslint-disable-next-line no-bitwise
  if (tournFlags & TournFlags.TOURNSCRIPT_FLAG_REBUYENABLE) {
    return `${imageUrl}rebuy${TILE_IMAGE_FORMAT}`;
  }

  return defaultImage(game, structure, buyIn, 0, isHiLo, 0);
}
